import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { take, takeUntil, tap } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { FORM_CONFIG as formConfig } from '../labels-f4';
import { PaisesListarService } from '../../../core/providers/services/paises-listar/paises-listar.service';

import { FormPropModel } from '../../../core/models/form-prop.model';
import { CountryListModel } from '../../../core/models/country-list.model';
import { SelectMultipleModel } from '../../../core/models/select-multiple.model';
import { PrefijoPaisesService } from 'src/app/core/providers/services/prefijo-paises/prefijo-paises.service';
import { Numbers } from 'src/app/utils/constants';

@Component({
  selector: 'app-legal-particular',
  templateUrl: './legal-particular.component.html',
  styleUrls: ['./legal-particular.component.scss']
})
export class LegalParticularComponent implements OnInit, OnDestroy {

  /**
   * @description Es el formulario
   */
  @Input() formData: FormGroup;

  /**
   * @description Emite la opción de gracias para formularios sin TPV
   */
  @Output() clickThanks: EventEmitter<'thanks' | ''> = new EventEmitter();

  /**
   * @description Es el formulario
   */
  formConfig: any;
  currentStep = 1;
  modifyStepV = '';
  insureForm = '';

  /**
   * @description Subject para finalizar suscripciones
   */
  private finish = new Subject();

  /**
   * @description Es un modelo de datos para el componente de botón
   */
  public dataButton = new FormPropModel({ classes: 'green', label: 'Siguiente' });

  public insuredChoosed: 'Particular' | 'Empresa' = 'Particular';
  /**
   * @description constructor
   * @params plSrv
   */
  constructor(
    private plSrv: PaisesListarService,
    private prefixSrv: PrefijoPaisesService
  ) {
    this.plSrv = plSrv;
    this.prefixSrv = prefixSrv;
  }

  newFormConfig: any = {
    ...formConfig
  };
  /**
   * @description Metodo de inicio
   */
  ngOnInit(): void {
    this.newFormConfig.currentStep.pipe(
      take(1)
    ).subscribe(step => {
      this.currentStep = step;
    });
    this.getCurrentStep();
    this.subs();
    // Obtenemos el listado de prefijos telefónicos
    this.prefixSrv.getPrefix()
      .pipe(take(1))
      .subscribe((prefijo) => {
        this.newFormConfig.insuredData.prefix.options.list = prefijo;
      });
    this.plSrv.getCountryList()
      .pipe(take(1))
      .subscribe((paisesList: any[]) => {
        // Pais Destino - Multiple
        const countryList: CountryListModel[] = paisesList.map(s => new CountryListModel(s));
        const multipleCountryList: SelectMultipleModel[] = countryList.map(u => new SelectMultipleModel(u));
        // El primer pais es "Seleccionar" por eso lo eliminamos.
        // multipleCountryList.shift();
        // Pais Origen - Simple
        const simpleCountryList: any[] = multipleCountryList.map(r => r.value);
        this.newFormConfig.insuredData.country.options.list = simpleCountryList;
        // this.newFormConfig.insuredData.rentedHouseData.country.options.list = simpleCountryList;
        this.newFormConfig.insuredData.rentedHouseData.country.options.list = simpleCountryList.sort((a, b) => a.name - b.name);
        this.insureForm = this.newFormConfig.codePromotional.linkFormPath[0];
        this.formConfig = this.newFormConfig;
      });
  }
  /**
   * @description Metodo de fin
   */
  ngOnDestroy(): void {
    this.finish.next(true);
  }

  /**
   * @description Cambia el valor del formulario
   */
  private subs(): void {
    if (!this.formData) { return; }
    this.formData.valueChanges.pipe(
      takeUntil(this.finish),
      tap(el => {
      })
    ).subscribe();
  }
  /**
   * @description Consigue el valor de una propiedad del formulario
   */
  public getCurrentStep(): void {
    const number4: number = Numbers.number4;
    this.newFormConfig.currentStep.pipe(
      takeUntil(this.finish)
    ).subscribe(step => {
      this.currentStep = step;
      if (this.currentStep === number4) {
        this.clickThanks.emit('thanks');
      }
    });
  }

  /**
   * @description Cambio de paso, siguiente o anterior
   */
  public modifyStep(ev: 'back' | 'next'): void {
    if (ev === 'next') {
      this.formConfig.stepIncrement();
    }
    if (ev === 'back') {
      this.formConfig.stepDecrement();
    }

    this.modifyStepV = ev;
  }

  /**
   * @description Cambio de tomador particular o empresa
   */
  changeInsuredType(ev: 'Particular' | 'Empresa'): void {
    this.insuredChoosed = ev;
  }

  /**
   * @description Retorna el tipo de tomador particular o empresa
   */
  getInsuredTypeChoosed(): 'Particular' | 'Empresa' {
    return this.insuredChoosed;
  }
}
